import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetAllNotificationQuery } from "../redux/api/notificationApi";

export default function useNotification() {
  const [notification, setNotifications] = useState([]);
  const { agentId } = useSelector((state) => state.auth);

  const { data } = useGetAllNotificationQuery(agentId);

  useEffect(() => {
    if (data) {
      setNotifications(data);
    }
  }, [data]);

  useEffect(() => {
    if (!window.$ || !window.$.hubConnection) {
      console.error("SignalR client library not loaded or jQuery is missing");
      return;
    }

    const connection = window.$.hubConnection(
      "https://data.realtorscrm.com/signalr",
      {
        qs: {
          id: agentId,
          type: "3",
          token: localStorage.getItem("token"),
        },
      }
    );

    const hub = connection.createHubProxy("notifcationHub");

    hub.on("receiveNotification", (data) => {
      console.log("🔔", data.message);

      setNotifications((prev) => [
        ...prev,
        {
          description: data.message,
          notificationId: 0,
          readDate: null,
          receiverId: 140,
          receiverType: 2,
          sendDate: "2025-07-08T23:39:50.803",
          senderId: 140,
          senderType: 2,
          status: 0,
        },
      ]);
    });

    connection
      .start()
      .done(() => console.log("✅ Connected to SignalR"))
      .fail((err) => console.error("❌ SignalR error", err));

    return () => {
      connection.stop();
    };
  }, [agentId]);

  return notification;
}
